import { render, staticRenderFns } from "./fav.vue?vue&type=template&id=32747a6d&scoped=true"
import script from "./fav.vue?vue&type=script&lang=js"
export * from "./fav.vue?vue&type=script&lang=js"
import style0 from "./fav.vue?vue&type=style&index=0&id=32747a6d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32747a6d",
  null
  
)

export default component.exports